













































































//@ts-nocheck
//@ts-ignore
import { Component, Vue } from 'vue-property-decorator';


//@ts-ignore
import estrategias from '@/mixins/axios/pmd_estrategias'
//@ts-ignore
import TablePPoa from '@/components/tables/tablev1'
//@ts-ignore
import { email, required } from 'vuelidate/lib/validators';
//@ts-ignore
import Notiflix from "notiflix";
//import {Vuetable,VuetablePagination} from 'vuetable-2'
//@ts-ignore
import EstrategiaHeader from '@/components/headersSelect/estrategia'

@Component({
  components: {
   /*
    Vuetable,
    VuetablePagination,*/
    TablePPoa,
    EstrategiaHeader
  },
  data() {
    return {
        //idmunicipio,nombre, fecha_alta, 
            // tipo, total_empleados, nombre_titular, correo, abreviacion,
       columnasd:[
             
             
             
           
            
             {
                tag:'estrategias',
                data:'estrategias',
                active:true
            },
            {
                tag:'select_linea',
                data:'select',
                active:false
            },
             {
                tag:'delete',
                data:'delete',
                active:false
            },
            {
                tag:'edit',
                data:'edit',
                active:false
            },
       ],
   
    



        id:null as any,

      estrategia:'' as any,
         
              estrategias:[] as any,
      
    }
  },
     mixins: [estrategias],
     validations: {
    
           estrategia: {
      required,
    },
   
         
     

   
  },
  methods:{
      clearstate(){
this.$store.commit('SETESTRATEGIA',null);
 this.$router.push('/mun/general/pmd/ejes/estrategias')
        },
          select(row){

//alert('pmd seleccionado');
 //this.$store.state.pmd_sel=row;
 this.$store.commit('SETESTRATEGIA',row);
 console.log(row);

    this.$router.push('/mun/general/pmd/ejes/estrategias/lineasaccion')
 
           //this.secretaria_sel=row;
//this.departamentos=true;
 //this.$store.commit('SETSECRETARIA',row);
   
//this.getDataDepartamentos();

      
     },
      async eliminar(row){
this.$root.$emit('loading', true);
let data= await this.ELIMINAR_PMD_ESTRATEGIAS(row).then(response => {

                    if (response != null) {

 this.estrategias=this.estrategias.filter(item => item.id !== row.id);
 
                    } else {
                        this.$root.$emit("alerta_show", "Ocurrio un error al intentar eliminar Estrategias, refresque la página");

                    }
 this.$root.$emit('loading', false);
                });
      },
     
     confirm(row){

let th=this;
Notiflix.Confirm.Show('Alerta de confirmacion','Desea eliminar este elemento?','Aceptar','Cancelar',function(){ 
    
    th.eliminar(row);
    },function(){ 
      
        
    });



      
     },
      limpiar(){
this.id=null;
 
           
                 this.estrategia=null;
               

    
           
      },
      addRow(){
          this.limpiar();
 $('#ac_modal_estrategias').modal('show')
      },
seteditar(row){


 this.id=row.id;

  this.estrategia=row.estrategias;

          
             
 $('#ac_modal_estrategias').modal('show')
    

},
     async crear(dat){
let data= await this.CREAR_PMD_ESTRATEGIAS(dat).then(response => {

                    if (response != null) {
                        //this.plantas = response;
console.log(response)

  this.estrategias.push(response)
                    } else {
                        this.$root.$emit("alerta_show", "Ocurrio un error al intentar editar Estrategias, refresque la página");

                    }    $("#ac_modal_estrategias").modal("hide");
 this.$root.$emit('loading', false);
                    //loading.close();
                });

      },
     async editar(dat){


let data= await this.EDITAR_PMD_ESTRATEGIAS(dat).then(response => {

                    if (response != null) {
                        //this.plantas = response;
console.log(response)
 this.$root.$emit("success", "Estrategia modificada correctamente.");
  this.estrategias=this.estrategias.filter(item => item.id !== dat.id);
 this.estrategias.push(response)
                    } else {
                        this.$root.$emit("alerta_show", "Ocurrio un error al intentar crear Estrategias, refresque la página");

                    }
 this.$root.$emit('loading', false);
                    //loading.close();
                });


      }
     ,
     async GuardarData(){



console.log('id:'+this.id)

let dat={
  id:this.id,
     
        estrategias:this.estrategia,

ideje:this.$store.state.eje_sel.id,
//idobjetivo:this.$store.state.eje_sel.id,
        idpmd:this.$store.state.pmd_sel.id,
        idmunicipio:this.$store.state.user.usuario.id_municipio
    
}
console.log(dat)
 this.$root.$emit('loading', true);
 if(this.id==null){
     this.crear(dat);
 }else{
       this.editar(dat);
 }

      },
async getData() {
  
 this.$root.$emit('loading', true);
 console.log('loaddding')

let data2={
    idmunicipio:this.$store.state.user.usuario.id_municipio,
idpmd:this.$store.state.pmd_sel.id,
ideje:this.$store.state.eje_sel.id,
//idobjetivo:this.$store.state.eje_sel.id,


};


let data= await this.GET_PMD_ESTRATEGIAS(data2).then(response => {

                    if (response != null) {
                        //this.plantas = response;
                        
this.estrategias=response;
                    } else {
                        //this.$root.$emit("alerta_show", "Ocurrio un error al intentar cargar las plantas, refresque la pagina");
console.log('ocurrio un error')
                    }
                    this.$root.$emit('loading', false);

                    //loading.close();
                });
},



  },
  mounted(){
      this.getData();
      //alert('10')
  }
})
export default class Home extends Vue {}

